import { addDays, format } from 'date-fns';
import { utcDifferenceInDays } from 'server/helpers/utcDifferenceInDays';
import {
  EmploymentAvailabilityDay,
  EmploymentAvailabilityStatusEnum,
} from 'server/shared/models/user';
import { dbDayDateToken } from 'server/static/dbDayDateToken';

export type AvailabilityMatchPercentageRange = {
  days: number;
  dates: string[];
};
/**
 * This method acts as optimization to avoid calculating the same dates within a loop that calls "getAvailabilityMatchPercentage"
 * This method should be called before the loop in that case
 */
export function getAvailabilityMatchPercentageRange(
  fromDate: string,
  toDate: string,
): AvailabilityMatchPercentageRange {
  const days = utcDifferenceInDays(new Date(toDate), new Date(fromDate)) + 1;
  return {
    days,
    dates: Array.from({ length: days }, (_, i) =>
      format(addDays(new Date(fromDate), i), dbDayDateToken),
    ),
  };
}

export function getAvailabilityMatchPercentage(
  availabilityDays: EmploymentAvailabilityDay[],
  availabilityMatchPercentageRange: AvailabilityMatchPercentageRange,
  employmentWorkload: number,
  employmentId?: string,
) {
  const { days, dates } = availabilityMatchPercentageRange;
  const dayPercentage = 100 / days;
  let matchPercentage = 0;
  // loop dates
  for (let date of dates) {
    let day = availabilityDays.find((day) => day.date === date);
    if (
      day &&
      (day.status === EmploymentAvailabilityStatusEnum.AVAILABLE ||
        (day.status === EmploymentAvailabilityStatusEnum.WORKING &&
          day.employmentId === employmentId))
    ) {
      let dailyWorkload = day.workload || 100;
      if (dailyWorkload > employmentWorkload) {
        dailyWorkload = employmentWorkload;
      }
      if (day.status === EmploymentAvailabilityStatusEnum.AVAILABLE) {
        matchPercentage += (dayPercentage / employmentWorkload) * dailyWorkload;
      } else {
        matchPercentage += dayPercentage;
      }
    }
  }
  return Math.round(matchPercentage);
}
